import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-open_eye",
  "use": "icon-open_eye-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-open_eye\"><path fill=\"currentColor\" d=\"M924.1 446.3c-75.7-68.5-229.7-183.5-411-183.5-181.5 0-335.6 115.2-411.3 183.8-18 16.3-28.4 39.6-28.4 63.8 0 24.2 10.3 47.5 28.4 63.8C177.5 642.8 331.7 758 513.1 758c181.3 0 335.3-115 411-183.5 18.1-16.4 28.5-39.8 28.5-64.1 0-24.3-10.4-47.7-28.5-64.1z m-44.3 79.3C811.2 587.8 672.3 692 513.1 692c-159.3 0-298.3-104.4-367-166.7-5.8-5.3-6.7-11.6-6.7-14.9 0-3.3 0.9-9.7 6.7-14.9 68.7-62.3 207.6-166.7 367-166.7 159.1 0 298 104.3 366.7 166.4 5.9 5.3 6.8 11.8 6.8 15.2s-0.9 9.9-6.8 15.2z\" /><path fill=\"currentColor\" d=\"M513 378.4c-72.8 0-132.1 59.2-132.1 132.1s59.3 132 132.1 132 132.1-59.2 132.1-132.1-59.2-132-132.1-132z m0 198.1c-36.4 0-66-29.6-66-66s29.6-66 66-66 66 29.6 66 66-29.6 66-66 66z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/open_eye.svg
// module id = cATe
// module chunks = 63